export const paths = {
  main: "/"
};
